export default __webpack_public_path__ + "static/about-txt-kr-9290306ba555d5619e59300533663e9f.png";